import React, { useEffect, useMemo, useState } from "react";
import { Box, Flex, Text, useBreakpointValue } from "@chakra-ui/react";

import MapOverlayView from "./MapOverlayView";
import { useTranslation } from "next-i18next";
import appStore from "store";
import GCPImage from "components/GCPImage";
import AirportIcon from "../../../public/images/icons/AirportIcon";
import StationIcon from "../../../public/images/icons/StationIcon";
import { useRouter } from "next/router";

const MapPointPresentation = ({
  map,
  data,
  isOpen,
  onClick,
  groupPrice,
  index,
  instant_zone_ids,
}) => {
  const router = useRouter();
  const { locale } = router;
  const isTw = locale === "zh-TW";
  const { configs, selectedDays } = appStore;
  const { t } = useTranslation("common");
  const isDesktop = useBreakpointValue({ base: false, md: true });
  const { tempSelectedZoneId } = appStore;
  const [showPrice, setShowPrice] = useState({});

  const isInstantZone = useMemo(() => {
    return instant_zone_ids.includes(data.id);
  }, [instant_zone_ids, data.id]);

  // const isDisabled = useMemo(() => {
  //   if (data.availableCarList.length === 0) return true;

  //   let _isDisabled = true;
  //   data.availableCarList.forEach((item) => {
  //     const lastestOrderTimeHours = item.owner_settings.lastest_order_time / 60;
  //     const thisZoneConfig = item.owner_settings.support_zones.find(
  //       (zone) => zone.id.toString() === data.id.toString()
  //     );

  //     // 推算加上最快備車時間後的時間
  //     const endTime = addBufferHoursET(
  //       addHours(new Date(), 8),
  //       lastestOrderTimeHours,
  //       Number(thisZoneConfig.business_start_hour.split(":")[0]),
  //       Number(thisZoneConfig.business_end_hour.split(":")[0])
  //     );

  //     if (endTime < set(new Date(), { hours: data.openEd.split(":")[0] })) {
  //       _isDisabled = false;
  //     }
  //   });

  //   return _isDisabled;
  // }, [data.availableCarList, data.id, data.openEd]);

  // useEffect(() => {
  //   if (groupPrice.length === 0 || !data.lowestModel.model_name) return;
  //   setShowPrice(
  //     groupPrice.find(
  //       (item) =>
  //         item.model_name ==
  //         `${data.lowestModel.model_name}${data.lowestModel.version ? ` ${data.lowestModel.version}` : ""}`
  //     )
  //   );
  // }, [
  //   data.lowestModel,
  //   data.lowestModel.model_name,
  //   data.lowestModel.version,
  //   groupPrice,
  // ]);

  // console.log("groupPrice", groupPrice);
  // console.log("data", data);
  // console.log("showPrice", showPrice);

  if (typeof data.lat !== "number" || typeof data.lng !== "number") {
    console.log("data", data);

    return <></>;
  }

  return (
    <>
      {map && (
        <MapOverlayView
          position={{ lat: data.lat, lng: data.lng, id: data.id }}
          map={map}
          active={isOpen}
        >
          <Flex
            direction="column"
            justifyContent="center"
            alignItems="center"
            position="relative"
            onTouchStart={(e) => {
              // Avoid click event on Google Map.
              if (e.cancelable) {
                e.stopPropagation();
              }
            }}
            onClick={(e) => {
              // Avoid click event on Google Map.
              if (e.cancelable) {
                e.stopPropagation();
              }
            }}
          >
            <Flex
              position="relative"
              justify="center"
              align="center"
              pl="8px"
              pr="16px"
              py="8px"
              borderRadius="18px"
              borderTopRightRadius={isInstantZone ? "0px" : "18px"}
              bg={
                // data.hasAvailableCar
                true
                  ? tempSelectedZoneId === data.id
                    ? "#28292B"
                    : "white"
                  : "#BDC3D0"
              }
              zIndex={tempSelectedZoneId === data.id ? 100 : 1}
              onClick={onClick}
              boxShadow="0px 1px 5px 0px rgba(0, 0, 0, 0.3)"
            >
              {isInstantZone && (
                <Box pos="absolute" top="-20px" right="0">
                  <GCPImage
                    src={`/images/icons/instant${isTw ? "" : "En"}.svg`}
                    alt="icon"
                    height="20px"
                  />
                </Box>
              )}
              {data.icon === "airport" && (
                <AirportIcon
                  mr="4px"
                  color={
                    // data.hasAvailableCar
                    true
                      ? tempSelectedZoneId === data.id
                        ? "#333333"
                        : "white"
                      : "#BDC3D0"
                  }
                  bgColor={
                    // data.hasAvailableCar
                    true
                      ? tempSelectedZoneId === data.id
                        ? "white"
                        : "#333333"
                      : "white"
                  }
                />
              )}
              {data.icon === "station" && (
                <StationIcon
                  mr="4px"
                  color={
                    // data.hasAvailableCar
                    true
                      ? tempSelectedZoneId === data.id
                        ? "#333333"
                        : "white"
                      : "#BDC3D0"
                  }
                  bgColor={
                    // data.hasAvailableCar
                    true
                      ? tempSelectedZoneId === data.id
                        ? "white"
                        : "#333333"
                      : "white"
                  }
                />
              )}
              <Text
                pl={data.icon !== null && data.icon !== "" ? "0px" : "8px"}
                as="span"
                fontSize="14px"
                fontWeight="700"
                lineHeight="20px"
                color={
                  // data.hasAvailableCar
                  true
                    ? tempSelectedZoneId === data.id
                      ? "white"
                      : "#333333"
                    : "white"
                }
                fontFamily="Poppins, sans-serif"
              >
                {/* ${showPrice.avgAmount} */}
                {t(`station_i18n.${data.level_3}`, {
                  defaultValue: data.level_3,
                })}
              </Text>
              {/* <Text
                as="span"
                fontSize="14px"
                fontWeight="700"
                lineHeight="20px"
                color={
                  data.hasAvailableCar
                    ? tempSelectedZoneId === data.id
                      ? "white"
                      : "#333333"
                    : "white"
                }
              >
                {" "}
                {t("Station_map_point")}
              </Text> */}
            </Flex>
            {/* {isOpen && isDesktop && <MapPointCard data={data} />} */}
            {/* <button onClick={onClick}>
              <Image
                src={
                  data?.subscription_solution?.fully_booked
                    ? mapBlackWhiteMarkerImage
                    : mapMarkerImage
                }
                alt="租"
                width="30px"
                height="45px"
                priority
              />
            </button> */}
            {/* {data?.min_price > 0 ? (
              <MapPointButton
                text={`$${data.min_price}起`}
                onClick={onClick}
                isOpen={data.isOpen}
              />
            ) : (
              <button onClick={onClick}>
                <Image src={mapMarkerImage} alt='租' width={40} height={40} />
              </button>
            )} */}
          </Flex>
        </MapOverlayView>
      )}
    </>
  );
};

export default MapPointPresentation;
